import Reset from "./Reset.component";

export default Reset;
